import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

// Styles - use local CSS which imports shared styles via relative paths
import './assets/main.css'

// product.css is now the only design system — no body class scope needed.

const app = createApp(App)

// Plugins
app.use(createPinia())
app.use(router)

// Initialize auth from storage
import { useAuthStore } from '@omnidars/shared/stores/auth'
const authStore = useAuthStore()
authStore.initFromStorage()

app.mount('#app')
